<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <form v-if="showFilters" class="px-4">
          <div class="vx-row">
            <div class="xl:w-1/4 md:w-1/3 w-full mt-1 md:pl-2">
              <label class="vs-input--label">{{
                $t("InventoryTransactionOperationType")
              }}</label>
              <div class="w-full">
                <v-select
                  label="name"
                  name="transactionOperationType"
                  :options="TransactionOperationTypes"
                  v-model="gridSearchData.operationType"
                  :reduce="(x) => x.id"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('transactionOperationType')"
                  >{{ errors.first("transactionOperationType") }}</span
                >
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/3 w-full md:pl-2">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                :clearable="true"
              />
            </div>
            <div class="xl:w-1/4 md:w-1/3 w-full xl:pl-2">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                :clearable="true"
              />
            </div>
            <div class="xl:w-1/4 w-full pt-6 flex flex-row justify-end gap-2">
              <vs-button
                type="filled"
                class="whitespace-no-wrap"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
              <vs-button
                class="whitespace-no-wrap"
                type="filled"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
            </div>
          </div>
        </form>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('CreateOn'), sort: 'CreateOn' },
                {
                  title: $t('InventoryTransactionId'),
                  sort: 'InventoryTransactionId',
                },
                { title: $t('OperationType'), sort: 'OperationType' },
                { title: $t('Applicant'), sort: 'Applicant' },
                { title: $t('StoreName'), sort: 'StoreName' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 14%; direction: ltr">
                  {{ row.persianDateTime }}
                </td>
                <td style="width: 12%">
                  {{ row.inventoryTransactionId }}
                </td>
                <td style="width: 22%">
                  <span v-if="row.transactionType == 'CheckOut'">{{
                    $t("CheckOutTransaction")
                  }}</span>
                  <span v-if="row.transactionType == 'CheckIn'">{{
                    $t("CheckInTransaction")
                  }}</span>
                  <span v-if="row.transactionType == 'Transfer'">{{
                    $t("TransferTransaction")
                  }}</span>
                  <span
                    v-if="
                      row.transactionType == 'CheckOutForDischargePermission'
                    "
                    >{{ $t("CheckOutTransaction") }}</span
                  >
                  <span v-if="row.transactionType == 'CheckInWithExcelFile'">{{
                    $t("CheckInWithExcelFile")
                  }}</span>
                  <span v-if="row.transactionType == 'CheckInForReturnOrder'">{{
                    $t("CheckInForReturnOrder")
                  }}</span>
                </td>
                <td style="width: 15%">
                  {{ row.inventoryOperatorName }}
                </td>
                <td style="width: 14%">
                  {{ row.storeName }}
                </td>
                <td style="width: 20%">
                  <router-link
                    :to="{
                      path:
                        '/InventoryTransactionOperation/Items/' +
                        row.inventoryTransactionId +
                        '/0',
                    }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="view-details"
                      v-has-permission="permission128"
                    >
                      {{ $t("ViewDetails") }}
                    </vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-6"></div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  background: #3ec9d6 !important;
}

.view-details {
  padding: 0.1rem 0.5rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}

.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
const dict = {
  custom: {
    stockid: {
      required: "لطفا نام محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_invwetoryTransactions_Operation",
  data() {
    return {
      showFilters: false,
      permission128: "GetInventoryTransactionItemsByInventoryTransaction",
      fromDate: "",
      toDate: "",
      gridDataSource: {
        type: "app",
        service: "Inventory/api/InventoriesTransactionsOperationsQuery",
      },
      gridSearchData: {
        keyword: "",
        FromDate: "",
        ToDate: "",
        operationType: 1,
      },
      TransactionOperationTypes: [
        { name: "رسید ورود و حواله خروج", id: 1 },
        { name: "رسید ورود", id: 2 },
        { name: "حواله خروج", id: 3 },
        { name: "انتقال", id: 4 },
      ],
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    DataGrid,
  },
  methods: {
    submitFilter() {
      if (
        this.gridSearchData.FromDate == this.gridSearchData.ToDate ||
        this.gridSearchData.FromDate < this.gridSearchData.ToDate ||
        (this.gridSearchData.FromDate != "" && this.gridSearchData.ToDate == "")
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.filter = true;
            setTimeout(() => {
              this.$refs.grid.renderGrid(1, true);
            }, 0);
            this.disabled = false;
          }
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
        this.disabled = false;
      }
    },
    resetForm() {
      this.gridSearchData = {
        keyword: "",
        FromDate: "",
        ToDate: "",
        operationType: 1,
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
